import {
  GET_DASHBOARD_LATEST_TOURNMENT_LOADING,
  GET_DASHBOARD_LATEST_TOURNMENT_SUCCESS,
  GET_DASHBOARD_LATEST_TOURNMENT_ERROR,
} from "../../../constant/actionTypes";

const dashboardLatestPotyReducer = (
  state = {
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case GET_DASHBOARD_LATEST_TOURNMENT_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_LATEST_TOURNMENT_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DASHBOARD_LATEST_TOURNMENT_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};
export default dashboardLatestPotyReducer;
